import { Item } from 'src/app/models/item.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MainService } from '../main.service';
import { RespuestaModel } from '../../models/respuesta.model';
import { BehaviorSubject, Observable } from 'rxjs';
import * as SHA1 from 'js-sha1';
import { VariablesService } from '../variableGL.service';
import { error } from 'console';

@Injectable({
  providedIn: 'root'
})
export class LoginService extends MainService {
  private userSubject = new BehaviorSubject<any>(null);
  public user$ = this.userSubject.asObservable();

  constructor(public http: HttpClient, private variablesService: VariablesService) {
    super(http);
  }

autenticacionBoveda(usuario){
  return this.postAsync(this.servicesOIC + "api/Acceso/Login", usuario)
}

  //get
  async obtenerInformacionUsuario(){
    const respuestaOIC = await this.getAsync(this.servicesOIC + "api/Login/ObtenerInformacionUsuarioRol");

    if (!respuestaOIC.exito){
      this.variablesService.toastErr("El usuario no existe en el sistema OIC, comuniquese con el administrador.");
      throw new Error("Usuario no encontrado.");
    }
    localStorage.setItem("usuario", JSON.stringify(respuestaOIC.objeto));
    return respuestaOIC;
  }

  loginUser(token: string, refreshToken: string):void {
    localStorage.setItem('jwtToken', token);
    localStorage.setItem('refreshToken', refreshToken);
  }

  setUserData(userData: any){
    localStorage.setItem('usuario', JSON.stringify(userData));
    this.userSubject.next(userData);
  }

  loadUserFromStorage() {
    const savedUser = localStorage.getItem('usuario');
    if (savedUser) {
      this.userSubject.next(JSON.parse(savedUser));
    }
  }

  encryptPassword(psw: string) {
    const hash = SHA1(psw);
    return hash;
  }

}
